import types from "./usersTypes";

const initialState = {
    list: {
        content: [],
        pagination: {
            current_page: 0,
            last_page: 0,
            path: '',
            per_page: 0,
            total: 0,
        }
    },
    detail: {},
    loading: false
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = initialState, { type, payload }) => {
	switch (type) {
        case types.USERS_FETCHED:
			return {
				...state,
				list: payload.data || initialState.list,
                loading: false
			}
		case types.USERS_DETAIL_FETCHED:
			return {
				...state,
				detail: {
                    content: payload.data.content || initialState.detail,
                },
                loading: false
			}
		case types.USERS_LOADING:
			return {
				...state,
				loading: payload || initialState.loading,
			}
		default:
			return state;
	}
};